import React from 'react';
import { compose, withStateHandlers, withHandlers } from 'recompose';
import { Typo, Rhythm, Divider } from 'components/Layout';
import { Button } from 'components/Form/Button';
import { Icon } from 'components/Icon';
import { DatePicker } from 'components/Form/DatePicker';
import moment from 'moment';

import styles from './styles.css';
import { withTranslation } from 'react-i18next';

const format = (date) =>
  moment.isMoment(date) ? date.format('YYYY-MM-DD') : date;

export default compose<any, any>(
  withTranslation(),
  withStateHandlers(
    ({ state: { dates } }) => ({
      primary: dates[0] && dates[0].range,
      secondary: (dates[1] && dates[1].range) || dates[0].range,
    }),
    {
      onChangePrimary: (s) => (primary) => ({ ...s, primary }),
      onChangeSecondary: (s) => (secondary) => ({ ...s, secondary }),
    }
  ),
  withHandlers({
    onSubmit:
      ({ hideModal, state, primary, secondary }) =>
      () => {
        hideModal();
        state.onSubmit([
          { start: format(primary.start), end: format(primary.end) },
          { start: format(secondary.start), end: format(secondary.end) },
        ]);
      },
  })
)(
  ({
    hideModal,
    state: { title, description, limit },
    primary,
    secondary,
    onChangePrimary,
    onChangeSecondary,
    onSubmit,
    t,
  }) => (
    <div className={styles.root}>
      <div className={styles.header}>
        <Typo.Title size="small">{title}</Typo.Title>
        <Typo.Paragraph>{description}</Typo.Paragraph>
        <button onClick={hideModal} className={styles.close}>
          <Icon name="close" width={24} height={24} />
        </button>
      </div>
      <div className={styles.body}>
        <Rhythm>
          <Rhythm vertical>
            <Typo.Title size="small">
              {t('analytics:snapshot.revenue.baseline_report_modal')}
            </Typo.Title>
            <DatePicker
              limit={limit}
              value={primary}
              onChange={onChangePrimary}
              align="right"
            />
          </Rhythm>
          <div className={styles.divider} />
          <Rhythm vertical>
            <Typo.Title size="small">
              {t('analytics:snapshot.revenue.compare_to')}
            </Typo.Title>
            <DatePicker
              limit={limit}
              value={secondary}
              onChange={onChangeSecondary}
              align="right"
            />
          </Rhythm>
        </Rhythm>
        <Divider empty top={55} />
        <Rhythm right>
          <Button disabled={!primary || !secondary} onClick={onSubmit}>
            {t('common:general.done')}
          </Button>
        </Rhythm>
      </div>
    </div>
  )
);
